import { eventBusController } from '../../controller/rxjs-bus/event-bus-controller'

export class RxjsBusInitiate {
  public get Name(): string {
    return 'RXJS - Event Bus'
  }

  protected async _initFn(): Promise<void> {
    eventBusController().register()
  }

  protected async _destroyFn(): Promise<void> {
    eventBusController().unsubscribe()
  }
}
